import type { MovingMethodType } from '@/entities/visit-counsel/model/intake.types';

/**
 * 출발지/도착지 운반방식 옵션 (Figma "Q. 어떻게 운반하나요?").
 *
 * 옛 IntakeSectionForm 의 라벨과 일치한다.
 */
export const MOVING_METHOD_OPTIONS: ReadonlyArray<{
  value: MovingMethodType;
  label: string;
}> = [
  { value: 'ELEVATOR', label: '엘리베이터' },
  { value: 'LADDER_TRUCK', label: '사다리차' },
  { value: 'SKY_LIFT', label: '스카이' },
  { value: 'STAIR', label: '계단' },
  { value: 'FIRST_FLOOR', label: '1층' },
];

/** 운반방식 코드가 진입 위치(`entranceSpace`) 텍스트 입력을 요구하는지 */
export function requiresEntranceSpace(type: MovingMethodType | null | undefined): boolean {
  return type === 'LADDER_TRUCK' || type === 'SKY_LIFT';
}

/** 운반방식 코드가 계단 속성(경사로/계단수) 입력을 요구하는지 */
export function requiresStairAttributes(type: MovingMethodType | null | undefined): boolean {
  return type === 'FIRST_FLOOR';
}

/** 운반방식 코드가 엘리베이터 유무 추가 질문을 받는지 (Figma 스티키 메모: "엘리베이터 외 ⇒ 추가") */
export function requiresElevatorFollowup(type: MovingMethodType | null | undefined): boolean {
  return type === 'LADDER_TRUCK' || type === 'SKY_LIFT' || type === 'STAIR';
}
